// Hero Section Data Service
export const heroService = {
  getHeroData: () => {
    return {
      discount: "30% Discount first month purchase",
      heading: {
        line1: "Super Fast,",
        line2: "Advance & Safe,",
        line3: "Immigration Services",
      },
      description:
        "Fast immigration processing, 24/7 availability, experienced consultants, easy payment plans. Explore Our Services",
      ctaButton: "Get Started Now",
      imagePlaceholder: "935X641",
    };
  },
};

// Navigation Service
export const navigationService = {
  getNavigationItems: () => {
    return [
      "Home",
      "Services",
      "FAQs",
      "Service Area",
      "Articles",
      "Locations",
      "Contact",
      "Blog",
    ];
  },
};

// Customer Reviews Data Service
export const reviewsService = {
  getReviewsData: () => {
    return {
      title: "Our Customer Say Excellent",
      rating: 4.4,
      totalReviews: 9840,
      highlightedValue: "99X24",
      reviews: [
        {
          id: 1,
          name: "John Smith",
          rating: 5,
          comment: "Excellent service! Got me out quickly and professionally.",
          location: "Los Angeles, CA",
          image: "191X36",
        },
        {
          id: 2,
          name: "Sarah Johnson",
          rating: 5,
          comment:
            "Amazing experience. The team was very helpful and understanding.",
          location: "San Francisco, CA",
          image: "141X36",
        },
        {
          id: 3,
          name: "Mike Davis",
          rating: 4,
          comment: "Fast and reliable service. Highly recommend!",
          location: "San Diego, CA",
          image: "131X40",
        },
        {
          id: 4,
          name: "Lisa Wilson",
          rating: 5,
          comment:
            "Professional and efficient. Made a difficult situation much easier.",
          location: "Sacramento, CA",
          image: "111X40",
        },
        {
          id: 5,
          name: "Robert Brown",
          rating: 5,
          comment: "Outstanding service! Available 24/7 and very responsive.",
          location: "Fresno, CA",
          image: "166X34",
        },
        {
          id: 6,
          name: "Jennifer Garcia",
          rating: 4,
          comment:
            "Great team, very knowledgeable and helpful throughout the process.",
          location: "Oakland, CA",
          image: "147X28",
        },
      ],
    };
  },
};

// Services Section Data Service
export const servicesService = {
  getServicesData: () => {
    return {
      title: "We Provide Professional Immigration Services",
      subtitle:
        "No matter the immigration case or circumstance, Citizen Hub Immigration Services is here to help you navigate your path to citizenship and peace of mind.",
      services: [
        {
          id: 1,
          icon: "32X38",
          title: "Emergency Immigration Assistance",
          description:
            "When time matters most, our emergency immigration team is available 24/7 to provide immediate consultation and guidance for urgent cases.",
          features: [
            "24/7 emergency response",
            "Same-day consultation",
            "Direct coordination with immigration authorities",
          ],
          imagePlaceholder: "252X334",
        },
        {
          id: 2,
          icon: "40X42",
          title: "Family Sponsorship",
          description:
            "Reunite with your loved ones. Our experienced consultants handle family-based immigration cases with care and precision to bring families together.",
          imagePlaceholder: "239X161",
        },
        {
          id: 3,
          icon: "40X40",
          title: "Work Visas",
          description:
            "For employment-based immigration, we offer comprehensive support with quick approval processing, affordable rates, and personalized attention throughout your journey.",
          imagePlaceholder: "242X160",
        },
        {
          id: 4,
          icon: "44X44",
          title: "Green Card Applications",
          description:
            "Permanent residency requires expert handling and precise documentation. We work closely with USCIS to ensure your application is complete and compliant.",
          imagePlaceholder: "230X135",
        },
        {
          id: 5,
          icon: "44X44",
          title: "Citizenship Applications",
          description:
            "We provide compassionate support for naturalization cases. Our consultants ensure a smooth and respectful process while protecting your rights.",
          imagePlaceholder: "226X124",
        },
        {
          id: 6,
          icon: "44X44",
          title: "Complex Immigration Cases",
          description:
            "For complex immigration matters, we offer expert consultation, confidentiality, and full-service coordination with immigration attorneys and authorities.",
          features: [
            "Expert case analysis",
            "Confidential and secure service",
            "Dedicated senior consultant support",
          ],
          imagePlaceholder: "253X334",
        },
      ],
    };
  },
};

// About Us Section Data Service
export const aboutUsService = {
  getAboutUsData: () => {
    return {
      mainHeading: "Fast, Honest, and Reliable Immigration Services.",
      descriptionParagraph1:
        "At Citizen Hub Immigration Services, we believe everyone deserves a clear path to citizenship. Our experienced specialists are available 24/7 to provide fast, confidential, and affordable immigration assistance for you or your loved ones. We handle every case with care, integrity, and complete discretion.",
      descriptionParagraph2:
        "With years of experience navigating U.S. immigration forms and processes, our team ensures a smooth, stress-free journey from start to finish. Whether it's day or night, we'll stand by you—offering guidance, flexible payment options, and personal support every step of the way.",
      contactInfo: {
        callsLabel: "Immigration Support ( 24/7 Available )",
        phoneNumber: "+1 3108802133",
      },
      imagePlaceholder: "648X524",
      featureCards: [
        {
          id: 1,
          icon: "dashboard",
          title: "Simple Process",
          description:
            "We make immigration forms easy. Step-by-step guidance, clear instructions, and no hidden fees.",
        },
        {
          id: 2,
          icon: "request",
          title: "Fast Processing",
          description:
            "We work efficiently to help you complete and submit your immigration forms accurately and quickly.",
        },
        {
          id: 3,
          icon: "ongoing",
          title: "24/7 Support",
          description:
            "Our specialists are always available—day, night, weekends, and holidays. We never stop working for you.",
        },
        {
          id: 4,
          icon: "complete",
          title: "Full Guidance",
          description:
            "From the first consultation to final approval, we walk you through every step with professionalism and care.",
        },
      ],
    };
  },
};

// Why Choose Us Data Service
export const whyChooseService = {
  getWhyChooseData: () => {
    return {
      title: "Why Choose Us",
      features: [
        {
          id: 1,
          icon: "dollar",
          title: "Affordable Immigration Services",
          description:
            "Competitive rates and flexible payment plans that work with your budget. No hidden fees or surprise charges.",
        },
        {
          id: 2,
          icon: "clock",
          title: "24/7 Availability",
          description:
            "Round-the-clock service when you need us most. Our experienced consultants are always ready to help, day or night.",
        },
        {
          id: 3,
          icon: "shield",
          title: "Fast & Confidential",
          description:
            "Quick processing with complete discretion. We understand the sensitive nature of immigration matters.",
        },
        {
          id: 4,
          icon: "handshake",
          title: "Experienced Consultants",
          description:
            "Professional consultants with years of experience navigating the U.S. immigration process efficiently and effectively.",
        },
        {
          id: 5,
          icon: "certificate",
          title: "Licensed & Certified",
          description:
            "Fully certified immigration services provider with a proven track record of successful applications.",
        },
        {
          id: 6,
          icon: "phone",
          title: "Free Consultation",
          description:
            "No-obligation consultation to discuss your situation and explore the best options for your immigration case.",
        },
      ],
      highlightedCard: {
        title: "Fast Processing Guarantee",
        description:
          "We guarantee to review your immigration forms within 2 hours during business hours, or your consultation fee is free.",
        buttonText: "View Details →",
        imagePlaceholder: "216X198",
      },
    };
  },
};

// Pricing Plans Data Service
export const pricingService = {
  getPricingData: () => {
    return {
      title: "Pick your perfect plan",
      tabs: [
        { id: "web-hosting", label: "Web Hosting", active: false },
        { id: "wp-hosting", label: "WP Hosting", active: false },
        { id: "reseller-hosting", label: "Reseller Hosting", active: false },
        { id: "vps-hosting", label: "VPS Hosting", active: true },
      ],
      plans: {
        "web-hosting": [
          {
            id: 1,
            title: "WordPress Hosting",
            subtitle: "Everything you need to created.",
            image: "72X69",
            originalPrice: "USD 11.00",
            discount: "20% OFF",
            currentPrice: "USD 2.49",
            period: "For 48-month term",
            features: [
              "1 Website",
              "10,000 Visits Monthly",
              "1 GB RAM",
              "Unlimited NVMe Storage",
              "FREE cPanel",
              "FREE & Auto SSL Certificate",
              "FREE Website Migrations",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
          {
            id: 2,
            title: "Reseller Hosting",
            subtitle: "Everything you need to created.",
            image: "72X72",
            originalPrice: "USD 15.00",
            discount: "25% OFF",
            currentPrice: "USD 3.99",
            period: "For 48-month term",
            features: [
              "1 Website",
              "10,000 Visits Monthly",
              "1 GB RAM",
              "Unlimited NVMe Storage",
              "FREE cPanel",
              "FREE & Auto SSL Certificate",
              "FREE Website Migrations",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
          {
            id: 3,
            title: "Shared Hosting",
            subtitle: "Everything you need to created.",
            image: "72X72",
            originalPrice: "USD 8.00",
            discount: "15% OFF",
            currentPrice: "USD 1.99",
            period: "For 48-month term",
            features: [
              "1 Website",
              "10,000 Visits Monthly",
              "1 GB RAM",
              "Unlimited NVMe Storage",
              "FREE cPanel",
              "FREE & Auto SSL Certificate",
              "FREE Website Migrations",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: true,
          },
          {
            id: 4,
            title: "Dedicated Hosting",
            subtitle: "Everything you need to created.",
            image: "72X72",
            originalPrice: "USD 25.00",
            discount: "30% OFF",
            currentPrice: "USD 7.99",
            period: "For 48-month term",
            features: [
              "1 Website",
              "10,000 Visits Monthly",
              "1 GB RAM",
              "Unlimited NVMe Storage",
              "FREE cPanel",
              "FREE & Auto SSL Certificate",
              "FREE Website Migrations",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
        ],
        "wp-hosting": [
          {
            id: 1,
            title: "WordPress Basic",
            subtitle: "Perfect for beginners.",
            image: "72X69",
            originalPrice: "USD 9.00",
            discount: "22% OFF",
            currentPrice: "USD 2.99",
            period: "For 48-month term",
            features: [
              "1 Website",
              "5,000 Visits Monthly",
              "512 MB RAM",
              "10 GB NVMe Storage",
              "FREE WordPress Setup",
              "FREE SSL Certificate",
              "FREE WordPress Migrations",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
          {
            id: 2,
            title: "WordPress Pro",
            subtitle: "For growing websites.",
            image: "72X72",
            originalPrice: "USD 18.00",
            discount: "28% OFF",
            currentPrice: "USD 4.99",
            period: "For 48-month term",
            features: [
              "3 Websites",
              "25,000 Visits Monthly",
              "2 GB RAM",
              "50 GB NVMe Storage",
              "FREE WordPress Setup",
              "FREE SSL Certificate",
              "FREE WordPress Migrations",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: true,
          },
          {
            id: 3,
            title: "WordPress Business",
            subtitle: "For business websites.",
            image: "72X72",
            originalPrice: "USD 35.00",
            discount: "31% OFF",
            currentPrice: "USD 9.99",
            period: "For 48-month term",
            features: [
              "10 Websites",
              "100,000 Visits Monthly",
              "4 GB RAM",
              "200 GB NVMe Storage",
              "FREE WordPress Setup",
              "FREE SSL Certificate",
              "FREE WordPress Migrations",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
          {
            id: 4,
            title: "WordPress Enterprise",
            subtitle: "For large enterprises.",
            image: "72X72",
            originalPrice: "USD 60.00",
            discount: "35% OFF",
            currentPrice: "USD 19.99",
            period: "For 48-month term",
            features: [
              "Unlimited Websites",
              "Unlimited Visits",
              "8 GB RAM",
              "500 GB NVMe Storage",
              "FREE WordPress Setup",
              "FREE SSL Certificate",
              "FREE WordPress Migrations",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
        ],
        "reseller-hosting": [
          {
            id: 1,
            title: "Reseller Starter",
            subtitle: "Start your hosting business.",
            image: "72X69",
            originalPrice: "USD 20.00",
            discount: "20% OFF",
            currentPrice: "USD 5.99",
            period: "For 48-month term",
            features: [
              "25 cPanel Accounts",
              "50 GB Storage",
              "500 GB Bandwidth",
              "FREE WHM",
              "FREE SSL Certificates",
              "FREE Website Builder",
              "FREE Reseller Tools",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
          {
            id: 2,
            title: "Reseller Pro",
            subtitle: "Grow your hosting business.",
            image: "72X72",
            originalPrice: "USD 40.00",
            discount: "25% OFF",
            currentPrice: "USD 9.99",
            period: "For 48-month term",
            features: [
              "100 cPanel Accounts",
              "200 GB Storage",
              "2 TB Bandwidth",
              "FREE WHM",
              "FREE SSL Certificates",
              "FREE Website Builder",
              "FREE Reseller Tools",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: true,
          },
          {
            id: 3,
            title: "Reseller Business",
            subtitle: "Scale your hosting business.",
            image: "72X72",
            originalPrice: "USD 80.00",
            discount: "30% OFF",
            currentPrice: "USD 19.99",
            period: "For 48-month term",
            features: [
              "250 cPanel Accounts",
              "500 GB Storage",
              "5 TB Bandwidth",
              "FREE WHM",
              "FREE SSL Certificates",
              "FREE Website Builder",
              "FREE Reseller Tools",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
          {
            id: 4,
            title: "Reseller Enterprise",
            subtitle: "Enterprise hosting solutions.",
            image: "72X72",
            originalPrice: "USD 150.00",
            discount: "35% OFF",
            currentPrice: "USD 39.99",
            period: "For 48-month term",
            features: [
              "Unlimited cPanel Accounts",
              "1 TB Storage",
              "10 TB Bandwidth",
              "FREE WHM",
              "FREE SSL Certificates",
              "FREE Website Builder",
              "FREE Reseller Tools",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
        ],
        "vps-hosting": [
          {
            id: 1,
            title: "VPS Starter",
            subtitle: "Perfect for small projects.",
            image: "72X69",
            originalPrice: "USD 30.00",
            discount: "20% OFF",
            currentPrice: "USD 7.99",
            period: "For 48-month term",
            features: [
              "1 vCPU",
              "1 GB RAM",
              "25 GB SSD Storage",
              "1 TB Bandwidth",
              "FREE cPanel",
              "FREE SSL Certificate",
              "FREE OS Installation",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
          {
            id: 2,
            title: "VPS Professional",
            subtitle: "For growing applications.",
            image: "72X72",
            originalPrice: "USD 60.00",
            discount: "25% OFF",
            currentPrice: "USD 14.99",
            period: "For 48-month term",
            features: [
              "2 vCPU",
              "2 GB RAM",
              "50 GB SSD Storage",
              "2 TB Bandwidth",
              "FREE cPanel",
              "FREE SSL Certificate",
              "FREE OS Installation",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: true,
          },
          {
            id: 3,
            title: "VPS Business",
            subtitle: "For business applications.",
            image: "72X72",
            originalPrice: "USD 120.00",
            discount: "30% OFF",
            currentPrice: "USD 29.99",
            period: "For 48-month term",
            features: [
              "4 vCPU",
              "4 GB RAM",
              "100 GB SSD Storage",
              "4 TB Bandwidth",
              "FREE cPanel",
              "FREE SSL Certificate",
              "FREE OS Installation",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
          {
            id: 4,
            title: "VPS Enterprise",
            subtitle: "For enterprise applications.",
            image: "72X72",
            originalPrice: "USD 200.00",
            discount: "35% OFF",
            currentPrice: "USD 49.99",
            period: "For 48-month term",
            features: [
              "8 vCPU",
              "8 GB RAM",
              "200 GB SSD Storage",
              "8 TB Bandwidth",
              "FREE cPanel",
              "FREE SSL Certificate",
              "FREE OS Installation",
              "30-Day Money-Back",
            ],
            buttonText: "Explore Now →",
            isPrimary: false,
          },
        ],
      },
    };
  },
};
